import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { aunjaiBackendService } from "../services/aunjai-backend.service";
import { containsOnlyNumber } from "../utils/util";
import { doesOtpMatchDefaultByPassOtp } from "../utils/otp";

export function useOTP({
  onOtpSuccess,
  pageData,
  msisdn,
  isFetchOtpOnFirstRender = false,
  allowOtpByPass = false,
}) {
  const [otpValues, setOtpValues] = useState(["", "", "", "", "", ""]);

  const navigate = useNavigate();

  const hasInputAllOTP = otpValues.every((val) => val !== "");

  const inputRefs = useRef([]);

  const [otpInfo, setOtpInfo] = useState(null);

  function resetOtpInput() {
    setOtpValues(["", "", "", "", "", ""]);
  }

  async function fetchNewOtp() {
    resetOtpInput();

    if (!msisdn) return;

    try {
      const otpInfo = await aunjaiBackendService.sendOTP({ msisdn });

      setOtpInfo(otpInfo);
    } catch (error) {
      alert(aunjaiBackendService.translateErrorMessage(error));
    }
  }

  useEffect(() => {
    if (!msisdn) return;

    if (isFetchOtpOnFirstRender) {
      fetchNewOtp();
    }
  }, [msisdn, isFetchOtpOnFirstRender]);

  useTrackOTPValues({
    otpValues,
    onOtpSuccess,
    hasInputAllOTP,
    otpInfo,
    handleVerifyOtp,
  });

  const handleOtpChange = (e, index) => {
    const value = e.target.value;

    if (value.length <= 1 && containsOnlyNumber(value)) {
      const newOtpValues = [...otpValues];

      newOtpValues[index] = value;

      setOtpValues((_) => newOtpValues);

      const isLastInput = index === otpValues.length - 1;

      const isInputEmpty = value === "";

      if (isInputEmpty && !isLastInput) {
        inputRefs.current[index - 1]?.focus();
      }

      if (!isInputEmpty && !isLastInput) {
        inputRefs.current[index + 1]?.focus();
      }

      if (!hasInputAllOTP) return;

      if (pageData && pageData === "profile") {
        navigate("/profile");
      } else if (pageData === "formProfile") {
        navigate("/loan-process/form-step1");
      }
    }
  };

  async function handleVerifyOtp() {
    if (allowOtpByPass && doesOtpMatchDefaultByPassOtp(otpValues)) {
      onOtpSuccess();
      return;
    }

    if (!otpInfo) {
      if (allowOtpByPass) {
        alert("รหัส OTP ไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง");
        return;
      }
      alert("ไม่สามารถยืนยัน OTP ได้ กรุณากดส่งอีกครั้ง");
      return;
    }

    try {
      const isOtpCorrect = await aunjaiBackendService.verifyOTP({
        ref: otpInfo.ref,
        otp: otpValues.join(""),
      });

      if (isOtpCorrect) {
        onOtpSuccess();
      } else {
        alert("รหัส OTP ไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง");
      }
    } catch (error) {
      alert(error.message);
    }
  }

  const handleKeyDown = (e, index) => {
    const hasPressedBackspace = e.key === "Backspace";
    const isOTPInputEmpty = !otpValues[index];
    const isFirstInput = index === 0;

    if (hasPressedBackspace && isOTPInputEmpty && !isFirstInput) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  return {
    otpValues,
    handleOtpChange,
    handleKeyDown,
    inputRefs,
    fetchNewOtp,
    otpInfo,
    handleVerifyOtp,
  };
}

function useTrackOTPValues({ onOtpSuccess, hasInputAllOTP, handleVerifyOtp }) {
  useEffect(() => {
    if (hasInputAllOTP) {
      handleVerifyOtp();
    }
  }, [hasInputAllOTP, onOtpSuccess]);

  return { hasInputAllOTP };
}
